try {
    if (window.FLEET_CONFIG.DD_RUM_ENABLED) {
        window.DD_RUM && window.DD_RUM.init({
            clientToken: window.FLEET_CONFIG.DD_CLIENT_TOKEN,
            applicationId: window.FLEET_CONFIG.DD_APPLICATION_ID,
            site: 'datadoghq.com',
            service: window.FLEET_CONFIG.DD_SERVICE,
            env: window.FLEET_CONFIG.DD_ENV,
            sessionSampleRate: parseInt(window.FLEET_CONFIG.DD_RUM_SESSIONSAMPLERATE, 10),
            sessionReplaySampleRate: 20,
            trackUserInteractions: true,
            trackResources: true,
            trackLongTasks: true,
            defaultPrivacyLevel: 'mask-user-input',
            version: '1.0.2',
        });
    }

    if (window.DD_RUM && window.FLEET_CONFIG.DD_RUM_ENABLED) {
        console.log('Session Replay Enabled');
        window.DD_RUM.startSessionReplayRecording();
    }
} catch (error) {
    console.log(error);
}
